// 营销接口
import axios from 'axios'

// 折扣列表(分页)
export function getDiscount(data) {
  return axios({
    url: `/api/ums/discount/listPage`,
    method: 'get',
    params: data
  })
}
// 折扣查询(不分页)
export function getDiscountAll(data) {
  return axios({
    url: `/api/ums/discount/list`,
    method: 'get',
    params: data
  })
}
// 新增折扣
export function addDiscount(data) {
  return axios({
    url: `/api/ums/discount/insert`,
    method: 'post',
    data
  })
}
// 折扣修改
export function updateDiscount(data) {
  return axios({
    url: `/api/ums/discount/update`,
    method: 'post',
    data
  })
}

// 删除折扣
export function deleteDiscount(id) {
  return axios({
    url: `/api/ums/discount/delete?id=${id}`,
    method: 'get',
  })
}

// 渠道列表(不分页)
export function getChannelAll() {
  return axios({
    url: `/api/pms/channel/list`,
    method: 'get',
  })
}
// 渠道列表(分页)
export function getChannelList(data) {
  return axios({
    url: `/api/pms/channel/listPage`,
    method: 'get',
    params: data
  })
}
// 新增渠道
export function insertChannel(data) {
  return axios({
    url: `/api/pms/channel/insert`,
    method: 'post',
    data
  })
}
// 修改渠道
export function updateChannel(data) {
  return axios({
    url: `/api/pms/channel/update`,
    method: 'post',
    data
  })
}

// 轮播图列举图片
export function carouselPicList(type) {
  return axios({
    url: `/api/ums/picture/listFile?type=${type}`,
    method: 'get'
  })
}

// get上传轮播图接口file，type
export function uploadFileCarousel(data) {
  return axios({
    url: `/api/ums/picture/uploadFile`,
    method: 'get',
    params: data
  })
}
// post上传轮播图接口file,type
export function uploadFilesCarousel(data) {
  return axios({
    url: `/api/ums/picture/uploadFile`,
    method: 'post',
    data,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}
// post轮播图删除 filePath
export function deleteFilesCarouse(filePath) {
  return axios({
    url: `/api/ums/picture/deleteFile?filePath=${filePath}`,
    method: 'post'
  })
}
// get轮播图删除filePath
export function deleteFileCarouse(filePath) {
  return axios({
    url: `/api/ums/picture/deleteFile?filePath=${filePath}`,
    method: 'get'
  })
}

// 小程序公告栏设置
// 列表(分页)
export function activityList(data) {
  return axios({
    url: `/api/ums/activity/listPage`,
    method: 'get',
    params: data
  })
}
// 新增
export function insertActivity(data) {
  return axios({
    url: `/api/ums/activity/insert`,
    method: 'post',
    data
  })
}

// 修改
export function updateActivity(data) {
  return axios({
    url: `/api/ums/activity/update`,
    method: 'post',
    data
  })
}

// 删除
export function deleteActivity(id) {
  return axios({
    url: `/api/ums/activity/delete?id=${id}`,
    method: 'get'
  })
}

// 分销管理
// 分销用户列表
export function commissionAll(data) {
  return axios({
    url: `/api/ums/member/commission/listPage`,
    method: 'get',
    params: data
  })
}

// 分销用户新增
export function insertCommission(data) {
  return axios({
    url: `/api/ums/member/commission/insert`,
    method: 'post',
    data
  })
}

// 分销用户修改
export function updateCommission(data) {
  return axios({
    url: `/api/ums/member/commission/update`,
    method: 'post',
    data
  })
}

// 通过分销用户ID查询用户集合
export function selectByMemberComm(id) {
  return axios({
    url: `/api/ums/member/commission/selectByMemberCommissionId?memberCommissionId=${id}`,
    method: 'get'
  })
}

// 通过用户ID查询分销用户
export function selectMemberId(id) {
  return axios({
    url: `/api/ums/member/commission/selectByMemberId?memberId=${id}`,
    method: 'get'
  })
}

// 分销用户初始化提成修改
export function updateComm(data) {
  return axios({
    url: `/api/ums/member/commission/updateComm`,
    method: 'post',
    data
  })
}

// 查询分销用户初始化提成
export function selectCommission() {
  return axios({
    url: `/api/ums/member/commission/selectUmsCommission`,
    method: 'get'
  })
}

// 通过手机号查询用户提现金额详情
export function cashDetail(phone){
   return axios({
    url: `/api/ums/member/commission/cashDetail?phone=${phone}`,
    method: 'get'
  })
}

// 通过手机号查询用户提现金额记录
export function cashRecharge(phone){
   return axios({
    url: `/api/ums/member/commission/cashRecharge?phone=${phone}`,
    method: 'get'
  })
}

// 分销记录状态更改
export function updateCommisRecords(data){
  return axios({
    url:`/api/ums/member/commission/updateCommissionRecords`,
    method:'post',
    data
  })
}

// 分销记录列表
export function recordListAll(data){
   return axios({
    url: `/api/ums/member/commission/listRecordPage`,
    method: 'get',
    params:data
  })
}